// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* add css module styles here (optional) */
.input-tags:focus {
  outline: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-bootstrap-tagsinput/dist/index.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,UAAU;AACZ","sourcesContent":["/* add css module styles here (optional) */\n.input-tags:focus {\n  outline: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
